<template>
    <div class="section">
        <div class="bak">
            <h1 class="title is-size-2 is-size-3-mobile has-text-primary">Catering</h1>
            <p class="is-size-5 is-size-6-mobile has-text-white">Noen ganger passer det best å ha festen hjemme. Vi har flere cateringmenyer som er greie å håndtere. Dessverre kjører vi ikke ut mat - den må hentes hos oss. Det er også veldig sjelden vi har anledning til å leie ut kokker, men vi briefer dine kjøkkenassistener godt i forkant. </p>
            <p class="is-size-5 is-size-6-mobile has-text-white avsnitt">Etter at Covid-19 dukket opp ble det behov for å revurdere menyene våre. Dette av flere årsaker, ikke bare at det i perioder var uaktuelt å serveret fra buffet. Alle våre menyer er nå fremdeles til vurdering - sammen med betingelser og priser for catering. Disse sidene vil blli oppdatert så snart denne revurderingen er gjennomført. </p>
            <p class="is-size-5 is-size-6-mobile has-text-white avsnitt">Inntil videre har vi disse cateringmenyene å by på:</p>
        </div>

        <div class="columns is-multiline bokswhite">
            
            <!-- <div class="column is-one-third-tablet is-full-mobile">
                <h3 class="is-size-4 quote">Norsk julebrikke til 5 personer </h3>
                <p class="meny">
                    Skåret svineribbe, grov medister, røket laks, akevittsild, hjemmelaget sylte, roastbeef, sennep, eggerøre, remulade, sylteagurker, grillet sikori, svisker, aprikoser, eplemarmelade, rugbrød, grulrotbrød og smør. All mat leveres kald.
                </p>
                <p class="meny">
                    Du får en komplett boks med innhold til 5 personer som er klar til å settes rett på bordet. Ideelt til julelunsjer på jobben eller hjemme. Merk at denne pakken kun selges i intervaller på 5 porsjoner. Det medfølger ikke noe gods som skal returneres. 
                </p>
                <p class="allergener is-size-7">Inneholder sennep, fisk, melk, sulfitt, rug, havre, hvete, bygg og egg.</p>
                <p class="pris is-size-5">Kr. 950,-/pakke</p>
            </div>                    -->

            <div class="column is-one-third-tablet is-full-mobile">
                <h3 class="is-size-4 quote">Antipasti-boks til 5 personer </h3>
                <p class="meny">
                    Gode italienske oster, parmaskinke, salame Finnochiona , salame Barolo, prosciutto cotto, la  caprese, Kalamateoliven, artisjokkhjerter, eggerøre, foccacia og smør. All mat leveres kald.
                </p>
                <p class="meny">
                    Du får en komplett boks med innhold til 5 personer som er klar til å settes rett på bordet. Et ypperlig alternativ til julemat som kan serveres i private lag eller som en ekstra spesiell lunsj på jobben. Merk at denne pakken kun selges i intervaller på 5 porsjoner. Det medfølger ikke noe gods som skal returneres.  
                </p>
                <p class="allergener is-size-7">Inneholder egg, melk og sulfitt.</p>
                <p class="pris is-size-5">Kr. 950,-/pakke</p>
            </div>    

            <div class="column is-one-third-tablet is-full-mobile">
                <h3 class="is-size-4 quote">Desserter </h3>
                <p class="meny">
                    Panna cotta [inneholder melk] – kr. 65,- <br/>
                    Tiramisu [inneholder egg, melk og hvete] – kr. 65,-<br/>
                    Riskrem med bringebærcoulis [inneholder melk] – kr. 55,-<br/>
                </p>
            </div>  

            <!-- <div class="column is-two-thirds-tablet is-full-mobile">
                <img src="@/assets/images/food/julebrikke_1_1280px.jpg" alt="Bilde av julebrikken" />
            </div>

            <div class="column is-one-third-tablet is-full-mobile">
                <p class="is-size-5">Slik ser julebrikken vår ut rett ut i fra kjøkkenet. Det er bare å sette den rett på bordet!</p>
                <p class="is-size-5 avsnitt">Ypperlig som julelunsj på jobben, med syklubben eller familien. </p>
                <p class="is-size-5 avsnitt">En boks er beregnet på 5 voksne personer. Brikkene selges kun i intervaller på 5 porsjoner. </p>
            </div>     -->               
        </div> 

            <!--
            <p class="is-size-5 is-size-6-mobile has-text-white avsnitt">Her er en liste over de menyene vi har hatt tilgjengelige på disse sidene:
                <ul class="liste">
                    <li>Koldtbord</li>
                    <li>Spansk tapas</li>
                    <li>Spekemat</li>            
                    <li>Snitter</li>
                    <li>Gryter og supper
                        <ul class="liste">
                            <li>Kyllingcurry</li>
                            <li>Biff Stroganoff</li>
                            <li>Kalvefrikasè</li>
                            <li>Gyrosgryte</li>
                            <li>Lapskaus</li>
                            <li>Ertesuppe med flesk</li>
                            <li>Gulasjsuppe</li>
                        </ul>
                    </li>
                </ul>
            </p>
            -->

        <p class="has-text-centered avsnitt2">
            <a class="button is-large is-success" href="mailto:booking@generalhotell.no?subject=Cateringforespørsel">Send en forespørsel i dag!</a>
        </p>
    </div>
</template>

<script>
export default {
    title: 'Catering i Hønefoss | Catering i Hole | Selskapsmat ',
    metaInfo: {
        meta: [
        { name: 'description', content: 'Vil du helst ha festen hjemme? Da kan du bestille catering fra oss! Vi har menyer tilpasset alle typer selskaper - for catering i Hønefoss eller Hole.'},
        { name: 'keywords', content: 'catering, selskapsmat, takeaway, festmat, koldtbord, tapas, spansk tapas, gryteretter, 3-retter' }
        ]
    },        
}
</script>

<style scoped>
.bak {
    background-color: #000;
    opacity: 0.7;
    display: block;
    padding: 10px 10px 30px 10px;
    margin-bottom:100px;
}

.liste {
    list-style-type: circle;
    margin-left:20px;
}

.avsnitt {
    margin-top:1vw;
}

.avsnitt2 {
    margin-top:3vw;
    margin-bottom: 3vw;
}

.bokswhite {
    background-color: #ffffff;
    border: 1px solid #000000;    
    padding: 10px;
}

.meny {
    margin-top:15px;
}

.allergener {
    margin-top:10px;
}

.pris {
    margin-top:15px;
}
</style>